import React, { useContext } from 'react';
import { translations } from './translations';

export type Lang = 'en' | 'es';

export const I18nContext = React.createContext<{ lang: Lang; setLang: React.Dispatch<React.SetStateAction<Lang>> }>({
  lang: 'en',
  setLang: () => {},
});

function determineLocale(lang: Lang | string | undefined, ctx: React.ContextType<typeof I18nContext>): Lang {
  if (lang && (translations as any)[lang]) {
    return lang as Lang;
  }

  if (ctx && (translations as any)[ctx.lang]) {
    return ctx.lang;
  }

  return 'en';
}

export function useI18n(lang?: Lang | string | undefined) {
  const ctx = useContext(I18nContext);
  const locale = determineLocale(lang, ctx);
  function t(key: string) {
    return (translations as any)[locale][key] || key;
  }
  return { t, locale };
}
